<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="1909.000000pt" height="510.000000pt" viewBox="0 0 1909.000000 510.000000"
 preserveAspectRatio="xMidYMid meet">
<metadata>
Created by potrace 1.12, written by Peter Selinger 2001-2015
</metadata>
<g transform="translate(-48.000000,567.000000) scale(0.100000,-0.100000)" stroke="none">
<path d="M807 5343 l-327 -328 0 -1935 0 -1935 288 -288 287 -287 2005 0 2005
0 253 253 252 252 0 2020 0 2020 -278 278 -277 277 -1940 0 -1941 0 -327 -327z
m4371 -25 l203 -203 -1891 -3 -1890 -2 0 -1623 c0 -893 -2 -1626 -4 -1628 -2
-2 -95 -3 -205 -1 l-201 3 0 1829 0 1830 1893 0 1893 0 202 -202z m-4138
-1778 l0 -1830 1623 0 c893 0 1626 -2 1628 -4 2 -2 3 -99 1 -215 l-3 -211
-1822 2 -1822 3 -3 1849 -2 1850 192 193 c106 106 196 193 201 193 4 0 7 -823
7 -1830z m4380 -482 l0 -1903 -197 -197 c-109 -109 -201 -198 -205 -198 -5 0
-8 841 -8 1870 l0 1870 -1632 2 -1633 3 -3 215 c-1 118 0 220 2 227 4 11 363
13 1841 13 l1835 0 0 -1902z m-1129 1288 c2 -2 3 -563 1 -1245 l-2 -1241
-1275 0 -1275 0 0 1238 c0 681 3 1242 7 1245 7 7 2537 10 2544 3z m577 -1798
l-3 -1803 -1875 -3 -1875 -2 -192 192 c-106 106 -193 196 -193 200 0 5 835 8
1855 8 l1855 0 0 1605 0 1605 215 0 215 0 -2 -1802z"/>
<path d="M7500 3065 l0 -1005 190 0 190 0 0 676 0 677 24 -35 c13 -19 25 -39
27 -44 2 -5 83 -128 180 -274 147 -221 427 -645 616 -932 l45 -68 179 0 179 0
0 1005 0 1005 -190 0 -190 0 -2 -677 -3 -678 -116 175 c-247 373 -707 1073
-744 1132 l-30 47 -177 1 -178 0 0 -1005z"/>
<path d="M10310 3232 l0 -838 168 -167 168 -167 480 0 479 0 173 173 172 172
0 833 0 832 -200 0 -200 0 0 -762 0 -763 -71 -77 -71 -78 -277 0 -276 0 -78
78 -77 77 0 763 0 762 -195 0 -195 0 0 -838z"/>
<path d="M13015 4038 c4 -18 11 -49 15 -68 4 -19 27 -127 50 -240 23 -113 46
-223 51 -245 5 -22 16 -74 24 -115 14 -72 54 -268 110 -530 14 -69 32 -159 40
-200 8 -41 19 -93 24 -115 5 -22 27 -132 50 -244 23 -112 44 -208 47 -213 3
-4 87 -8 188 -8 l183 0 36 128 c20 70 52 183 72 252 20 69 54 188 76 265 23
77 52 178 66 225 13 47 28 99 33 115 5 17 20 68 33 115 14 47 40 136 58 199
25 88 34 109 42 96 5 -10 42 -135 82 -279 41 -143 80 -283 89 -311 8 -27 24
-84 35 -125 11 -41 38 -140 61 -220 23 -80 50 -179 61 -220 11 -41 24 -86 28
-100 5 -14 17 -51 26 -82 l17 -58 183 0 182 0 11 43 c7 23 17 69 23 102 6 33
15 78 20 100 5 22 15 72 23 110 18 90 58 287 91 440 14 66 41 197 60 290 19
94 46 224 60 290 33 153 74 352 90 435 24 121 34 165 40 183 7 16 -6 17 -193
17 -182 0 -201 -2 -206 -17 -5 -17 -11 -49 -41 -233 -8 -47 -19 -112 -25 -145
-6 -33 -17 -98 -25 -145 -8 -47 -19 -112 -25 -145 -6 -33 -17 -98 -25 -145 -8
-47 -19 -112 -25 -145 -6 -33 -17 -98 -25 -145 -8 -47 -19 -112 -25 -145 -6
-33 -14 -79 -17 -102 -7 -51 -19 -55 -28 -10 -4 17 -14 55 -22 82 -8 28 -18
66 -24 85 -11 41 -154 568 -169 620 -5 19 -11 44 -14 55 -2 11 -14 52 -25 90
-11 39 -44 154 -72 258 l-52 188 -150 -3 -151 -3 -9 -30 c-21 -71 -68 -241
-92 -330 -7 -27 -52 -185 -98 -350 -47 -165 -106 -374 -132 -465 -25 -91 -51
-181 -57 -200 l-12 -35 -8 35 c-4 19 -12 60 -17 90 -15 83 -60 343 -77 445 -9
50 -20 113 -24 140 -5 28 -16 91 -24 140 -8 50 -20 117 -26 150 -6 33 -17 98
-25 145 -8 47 -19 112 -25 145 -6 33 -14 75 -17 93 l-6 32 -200 0 -199 0 7
-32z"/>
<path d="M16470 3065 l0 -1005 195 0 195 0 0 1005 0 1005 -195 0 -195 0 0
-1005z"/>
<path d="M18172 3917 l-152 -152 0 -271 0 -270 159 -152 159 -152 374 0 374 0
47 -48 47 -48 0 -163 0 -164 -46 -53 -46 -54 -292 0 -292 0 -52 53 -52 53 0
82 0 82 -195 0 -195 0 0 -148 0 -148 159 -152 159 -152 464 0 463 0 158 151
157 151 0 298 0 298 -154 146 -154 146 -376 0 -377 0 -49 46 -50 47 0 151 0
152 48 47 48 47 280 0 280 0 46 -47 47 -48 3 -85 3 -85 193 -3 192 -2 0 151 0
151 -152 148 -153 149 -460 1 -460 0 -153 -153z"/>
</g>
</svg>
